var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"height":"100vh","display":"flex","flex-direction":"row","padding":"0","align-items":"center","flex-grow":"1"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }